import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { formatDateTimeShort } from "../../../../../utils/textUtils";

const DTRItineraryTable = ({ data, onEdit, onDelete, currentPage, setCurrentPage }) => {
  const headers = ["Time In", "Time Out", "Location", "Actions"];
  const accessors = ["itineraryTimeIn", "itineraryTimeOut", "itineraryLocation", "actions"];

  const actions = [
    {
      name: "Edit",
      tooltip: "Edit itinerary entry",
      icon: <EditIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600 flex items-center text-white p-1 rounded",
      function: onEdit,
      visible: true,
    },
    {
      name: "Delete",
      tooltip: "Remove itinerary entry",
      icon: <DeleteForeverIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600 flex items-center text-white p-1 rounded",
      function: onDelete,
      visible: true,
    }
  ];

  const renderCustomCell = (row, accessor) => {
    if (accessor === "itineraryTimeIn") return formatDateTimeShort(row[accessor]);
    if (accessor === "itineraryTimeOut") return formatDateTimeShort(row[accessor]);
    return null;
  };

  return (
    <CreateTable
      tableName={"Itinerary List"}
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={5}
      totalItems={data?.length}
      customCellRenderer={renderCustomCell}
    />
  );
};

export default DTRItineraryTable;